import { render, staticRenderFns } from "./add.vue?vue&type=template&id=5831ddf3&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5831ddf3')) {
      api.createRecord('5831ddf3', component.options)
    } else {
      api.reload('5831ddf3', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=5831ddf3&", function () {
      api.rerender('5831ddf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/convenientMaintenance/convenientMaintenanceManagement/add.vue"
export default component.exports